import { supabase } from './supabase';

/**
 * Order-niveau toeslag/kosten-producten (Bijrijdertoeslag, Transportkosten, …).
 * Prijs wordt server-side door PricingService bepaald — niet hier bekend.
 */
export interface FeeProduct {
  id: string;
  name: string;
  code: string;
  btw: string | null;
}

export interface FeeAddResult {
  success: boolean;
  message?: string;
  errorCode?: string;
  feeItemId?: string | null;
  newTotalInclBtw?: number | null;
}

async function authHeaders(): Promise<Record<string, string>> {
  const { data: { session } } = await supabase.auth.getSession();
  const h: Record<string, string> = { 'Content-Type': 'application/json' };
  if (session?.access_token) h['Authorization'] = `Bearer ${session.access_token}`;
  return h;
}

export async function fetchFeeProducts(): Promise<FeeProduct[]> {
  const headers = await authHeaders();
  const response = await fetch('/api/orders/wasserij-products?kind=fee', { headers });
  const data = await response.json().catch(() => ({}));
  return Array.isArray(data.products) ? (data.products as FeeProduct[]) : [];
}

export interface AddOrderFeeArgs {
  orderId: string;
  productId: string;
  quantity: number;
}

export async function addOrderFee(args: AddOrderFeeArgs): Promise<FeeAddResult> {
  const headers = await authHeaders();
  const response = await fetch('/api/orders/fee-add', {
    method: 'POST',
    headers,
    body: JSON.stringify({
      orderId: args.orderId,
      productId: args.productId,
      quantity: args.quantity,
    }),
  });
  const data = await response.json().catch(() => ({} as Record<string, unknown>));
  if (!response.ok && data.ok !== true) {
    return {
      success: false,
      message: (data.error as string) || `Toeslag toevoegen mislukt (${response.status})`,
      errorCode: data.code as string | undefined,
    };
  }
  return {
    success: data.ok === true,
    feeItemId: (data.feeItemId as string | null) ?? null,
    newTotalInclBtw: (data.newTotalInclBtw as number | null) ?? null,
  };
}
